/* eslint camelcase: 0 */

import axios from 'axios';
import {base_url,tokenConfig } from './common';



export function get_report_data_for_batch_id(batch_id){
    return axios.post(base_url+'reporting/get_report_for_batch',{'batch_id':batch_id}, tokenConfig());
}
export function get_all_ai_reports(){
    return axios.get(base_url+'reporting/get_all_ai_reports', tokenConfig());
}







